// Initialize accordions
function initAccordions() {
    const accordions = document.querySelectorAll(".js-accordion");

    // Function to close an accordion
    const closeAccordion = (accordion) => {
        const content = accordion.querySelector(".js-accordion-content");
        const button = accordion.querySelector("button");

        if (content && button) {
            content.style.height = "0px";
            accordion.classList.remove("is-active");
            button.style.transform = "rotate(0deg)";
        }
    };
    
    // Function to close all accordions
    const closeAllAccordions = () => {
        accordions.forEach(closeAccordion);
    };
    
    accordions.forEach((accordion) => {
        const heading = accordion.querySelector(".js-accordion-heading");
        const content = accordion.querySelector(".js-accordion-content");
        const button = heading.querySelector("button");
        
        if (!heading || !content || !button) return;
        
        heading.addEventListener("click", () => {
            const isOpen = content.style.height !== "0px";
            
            // Close all accordions first
            closeAllAccordions();
            
            // If the clicked accordion was closed, open it
            if (!isOpen) {
                content.style.height = `${content.scrollHeight}px`;
                accordion.classList.add("is-active");
                button.style.transform = "rotate(45deg)";
            }
        });
    });
}
  
// Initialize accordions when DOM is loaded
document.addEventListener('DOMContentLoaded', initAccordions);

// Re-initialize accordions when sections are loaded
document.addEventListener('shopify:section:load', initAccordions);